/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {fetchDataApiV3} from '../../../../../../services/cellcast.v3'
import {GetCurrentDataIsDefaultRegion} from '../../../../../Utils/_helpers/GetCurrentData'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  ApiList: [],
}

// export const GetTotalData: any = createAsyncThunk(thunkName.getToatal, async (data,thunkApi) => {
//   const response = await axios.get(`${API_URL}${RouteUrl.getTotal}`, {
//     params:data,
//     headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
//   })
//   thunkApi.dispatch(stopLoading())
//   return response.data
// })

export const getApiKeysListOfuser: any = createAsyncThunk(
  'getApiKeysListOfuser',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}user/token`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const CreateApiKeysListOfuser: any = createAsyncThunk(
  'CreateApiKeysListOfuser',
  async (data, thunkApi) => {
    const response = await axios.post(
      `${API_URL}user/token`,
      {name: data},
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(getApiKeysListOfuser())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const DeleteApiKeysListOfuser: any = createAsyncThunk(
  'DeleteApiKeysListOfuser',
  async (data, thunkApi) => {
    const response = await axios.delete(
      `${API_URL}user/token/${data}`,

      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(getApiKeysListOfuser())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const updateWebhook: any = createAsyncThunk('updateWebhook', async (data, thunkApi) => {
  thunkApi.dispatch(startLoadding())

  const isDefaultRegion = GetCurrentDataIsDefaultRegion()

  if (!isDefaultRegion) {
    const response = await fetchDataApiV3('setting', {
      action: 'update_webhook_setting',
      data,
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
  const response = await axios.post(
    `${API_URL}user/webhook`,
    data,

    {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    }
  )

  thunkApi.dispatch(stopLoading())
  return response.data
})
export const updateStatusOfApiKeys: any = createAsyncThunk(
  'updateStatusOfApiKeys',
  async (data: any, thunkApi) => {
    const response = await axios.put(
      `${API_URL}user/token/status/${data?.id}`,
      data.data,

      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi?.dispatch(getApiKeysListOfuser())
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const ApiKeys = createSlice({
  name: 'ApiKeys',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApiKeysListOfuser.fulfilled, (state, action) => {
      return {...state, ApiList: action?.payload}
    })
  },
})

export const getApikeyListData = (state: any) => state?.apikeys?.ApiList
export default ApiKeys.reducer
